import { Clock } from 'lucide-react';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { useGlobalPaywall } from '@/contexts/PaywallContext';
import { Button3D } from '@/components/ui/button-3d';

export function TrialBanner() {
  const { isInTrial, trialDaysRemaining } = useSubscription();
  const [, openPaywall] = useGlobalPaywall();

  if (!isInTrial || trialDaysRemaining === null || trialDaysRemaining > 3) {
    return null;
  }

  const suffix = trialDaysRemaining === 1 ? 'dia' : 'dias';
  const label = trialDaysRemaining === 0
    ? 'Seu trial acaba hoje'
    : `Seu trial acaba em ${trialDaysRemaining} ${suffix}`;

  return (
    <>
      <div
        className="mx-auto mt-2 flex max-w-lg items-center gap-3 rounded-lg border border-amber-300/60 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-500/40 dark:bg-amber-950/40 dark:text-amber-100"
        role="status"
      >
        <Clock className="h-4 w-4 shrink-0" aria-hidden />
        <span className="flex-1 font-medium">{label}</span>
        <Button3D
          color="amber"
          size="sm"
          className="shrink-0"
          onClick={() => openPaywall({ reason: 'feature' })}
        >
          Ver planos
        </Button3D>
      </div>
    </>
  );
}
